<template>
  <gw-entity-chooser
    class="a7-classificacao-indicador-entity-chooser"
    :search="search"
    :find-entity-by-id="findEntityByID" representation-field="caminho"
    bindByID v-model="computedValue" :selection-support="listing" :disabled="disabled"
    :defaultFilterParams="{ folha, 'tipo': [tipo] }">
    <template slot="item" slot-scope="{ entity }">
      <div>
        <strong>{{$t('ClassificacaoIndicador.ui.chooser.tipo')}} </strong>
        <span>{{$t(`ClassificacaoIndicador.tipo.${entity.tipo}`)}}</span>
      </div>
      <div>
        <strong>{{$t('ClassificacaoIndicador.ui.chooser.caminho')}} </strong>
        <span>{{entity.caminho}}</span>
      </div>
    </template>
  </gw-entity-chooser>
</template>

<script>
/**
 * @reference
 *  UI5064
*/
import { GwEntityChooser } from 'guaxinim-web'
import ClassificacaoIndicadorRestResource from './ClassificacaoIndicadorRestResource'
import A7ClassificacaoIndicadorListing from './A7ClassificacaoIndicadorListing'
import ClassificacaoIndicadorConstants from './ClassificacaoIndicadorConstants'

export default {
  name: 'a7-classificacao-indicador-entity-chooser',
  components: {
    GwEntityChooser
  },
  props : {
    value : {
      type: Object | Number
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tipo: {
      type: String
    },
    folha: {
      type: Boolean
    }
  },
  data(){
    return {
      listing: A7ClassificacaoIndicadorListing
    }
  },
  computed:{
    computedValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    }
  },
  methods: {
    search(pattern) {
      if (!pattern) return null
      return ClassificacaoIndicadorRestResource.findClassificacaoIndicadorFinderDTO(
        pattern, this.tipo, this.folha, 10);
    },
    findEntityByID(id) {
      return ClassificacaoIndicadorRestResource.findEntityByID(id)
    }
  }
}
</script>

<style lang="scss" scoped>
  .a7-classificacao-indicador-entity-chooser {
    width: 100%;
  }
</style>
